<template>
  <div class="user-info">
    <div class="user-head" v-if="appVersion === 'dd'">
      <div class="icon" @click="handleBack">
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <h3 class="title">个人信息</h3>
    </div>
    <div class="user-content" :class="{current: innerHeight < 500}">
      <div class="tips">请完善您的真实信息，否则可能会影响到您的学时记录</div>
      <div class="user-name">
        <h4>姓名</h4>
        <input type="text" v-model="username" maxlength="12" placeholder="输入要修改的姓名" />
      </div>
      <div class="check-box" v-show="orgShow">
        <h4>组织</h4>
        <div class="check-content" @click="pagejump('/customization/check-choice')">
          <div class="content" :class="choice ? 'current' : ''">
            {{ choice_next ? choice_next : choice ? choice : '请选择您所在的组织机构' }}
          </div>
          <i class="iconfont icon-arrow-down right"></i>
        </div>
      </div>
      <div class="check-box">
        <h4>学科</h4>
        <div class="check-content" @click="pagejump('/customization/check-subject')">
          <div class="content" :class="subjectText_next || subjectText ? 'current' : ''">
            {{ subjectText_next ? subjectText_next : subjectText ? subjectText : '请选择您的学科' }}
          </div>
          <i class="iconfont icon-arrow-down right"></i>
        </div>
      </div>
    </div>

    <div class="confirm" @click="handleConfirm">确定</div>
  </div>
</template>

<script>
import dd from 'dingtalk-jsapi'
import {getUser} from '@/api/index'
import {
  baseUserInfo,
  userInfoSubject,
  userInfoCancelOrg,
  userInfoApplyOrg,
  userInfoUpdate,
  userInfoSave,
  userInfoUpdateDD
} from '@/api/dd'
export default {
  name: 'dd-userinfo',
  data() {
    return {
      id: null,
      accountId: null,
      openAccountId: null,
      orgId: null,
      username: '',
      ddName: '',
      choice: null,
      choice_next: null,
      choiceId: null,
      subject: [],
      subject_next: null,
      subjectText: '',
      subjectText_next: '',
      teacherId: null,
      orgShow: true
    }
  },
  methods: {
    handleBack() {
      sessionStorage.removeItem('subject')
      sessionStorage.removeItem('subIdList')
      sessionStorage.removeItem('choice')
      sessionStorage.removeItem('ddName')
      this.$router.back()
    },
    pagejump(page) {
      this.$router.push(page)
      sessionStorage.setItem('ddName', this.username)
    },
    getUserInfo() {
      getUser().then(res => {
        if (res.code === 0) {
          const data = res.data
          this.id = data.id
          // if (sessionStorage.getItem("ddName")) {
          //   this.username = sessionStorage.getItem("ddName");
          // } else {
          //   this.username = data.name;
          // }
          this.choice = data.orgName
          this.choiceId = data.orgId
          this.accountId = data.id
        }
      })
    },
    getUserOhterInfo() {
      baseUserInfo().then(res => {
        this.teacherId = res.data.userInfoId
        this.openAccountId = res.data.openAccountId
        this.orgId = res.data.orgId
        this.username = res.data.trueName
        userInfoSubject(this.teacherId).then(res => {
          const subjects = res.data.data
          this.subject = subjects
          this.subject.forEach(item => {
            this.subjectText += `${item.stageName},${item.subjectName}、`
          })
        })
      })
    },
    // 注销机构并且重新加入机构
    applyOrg() {
      // 先注销
      return new Promise((resolve, reject) => {
        userInfoCancelOrg(this.openAccountId, this.orgId).then(res => {
          userInfoApplyOrg(this.openAccountId, this.choiceId).then(res => {
            if (res.code === 0 && res.success) {
              resolve(true)
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(false)
            }
          })
        })
      })
    },
    // 修改用户名
    updateName() {
      const params = {
        id: this.id,
        userName: this.username
      }
      return new Promise((resolve, reject) => {
        userInfoUpdate(params).then(res => {
          if (res.code === 0 && res.success) {
            if (res.data.code === 0) {
              resolve(true)
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          }
        })
      })
    },
    handleConfirm() {
      if (this.username.trim() === '') {
        this.$Toast.fail('姓名不能为空')
        return false
      } else if (!/^[[\u2E80-\uFE4F]{2,12}$/.test(this.username)) {
        this.$Toast.fail('姓名格式异常')
        return false
      } else if (!this.choice) {
        this.$Toast.fail('请选择组织')
        return false
      } else if (!this.subject) {
        this.$Toast.fail('请选择学科')
        return false
      } else {
        let subArr = this.subject_next ? this.subject_next : this.subject
        subArr = subArr.map(item => {
          item.stageName = item.stage
          item.subjectName = item.sub
          delete item.id
          delete item.stage
          delete item.sub
          return item
        })
        const orgId = this.choiceId_next ? this.choiceId_next : this.choiceId
        const orgName = this.choice_next ? this.choice_next : this.choice
        // const name = this.username
        const info = {
          interCoreUserBaseInfosInput: {
            id: this.id,
            userName: this.username
          },
          interTeacherSubject: {
            subjects: subArr,
            teacherId: this.teacherId
          },
          orgId: orgId
        }
        console.log('info', info)
        userInfoSave(info).then(res => {
          window.console.log('userInfoSave', res)
          if (res.code === 0) {
            sessionStorage.removeItem('subject')
            sessionStorage.removeItem('subIdList')
            sessionStorage.removeItem('choice')
            sessionStorage.removeItem('ddName')
            // this.handleConfirmDd(this.username, orgName)
            if (this.appVersion === 'dd') {
              this.$router.replace('/customization/check-success?choice=' + orgName)
            } else if (this.appVersion === 'vx') {
              window.wx.miniProgram.postMessage({
                data: '1001'
              })
              window.wx.miniProgram.navigateBack()
            }
          } else {
            this.$Toast.fail(res.data.msg)
          }
        })
      }
    },
    handleConfirmDd(username, orgName) {
      dd.runtime.permission.requestAuthCode({
        corpId: 'dingcc49658297bd767bf5bf40eda33b7ba0',
        onSuccess: info => {
          const code = info.code
          userInfoUpdateDD({
            name: username,
            type: 2,
            userCode: code
          })
            .then(res => {
              console.log('res', res)
              if (res.code === 0) {
                // 更改成功
                setTimeout(() => {
                  this.$router.replace('/customization/check-success?choice=' + orgName)
                }, 500)
              } else {
                this.$Toast.fail('保存失败')
              }
            })
            .catch(err => {
              console.log(err, err)
            })
        }
      })
    }
  },
  created() {
    this.innerHeight = window.innerHeight
    console.log('this.innerHeight', this.innerHeight)
    if (sessionStorage.getItem('subject')) {
      this.subject_next = JSON.parse(sessionStorage.getItem('subject'))
      this.subject_next.forEach(item => {
        this.subjectText_next += `${item.stage},${item.sub}、`
      })
    }
    if (sessionStorage.getItem('choice')) {
      const choiceObj = JSON.parse(sessionStorage.getItem('choice'))
      this.choice_next = choiceObj.displayName
      this.choiceId_next = choiceObj.id
    }

    this.getUserInfo()
    this.getUserOhterInfo()
  }
}
</script>

<style lang="scss" scoped>
.user-info {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  .user-head {
    position: relative;
    width: 100%;
    height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    .icon {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 100%;
      i {
        display: inline-block;
        font-size: 20px;
        font-weight: 700;
        transform: rotate(180deg);
      }
    }
    .title {
      line-height: 50px;
      font-size: 17px;
      font-weight: 700;
      text-align: center;
    }
  }
  .user-content {
    /* margin-top: 28px; */
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    &.current {
      height: 350px;
      overflow: scroll;
      padding: 0 15px 15px;
    }
    .tips {
      padding-top: 12px;
      color: red;
      font-weight: 500;
      font-size: 18px;
    }
    .user-name {
      margin-top: 36px;
      h4 {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
      }
      input {
        width: 100%;
        margin-top: 12px;
        padding: 18.5px 17px;
        box-sizing: border-box;
        background: #f4f6f9;
        border-radius: 12px;
        border: none;
        outline: none;
        color: #303133;
        font-size: 15px;
      }
    }
    .check-box {
      margin-top: 22px;
      h4 {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
      }
      .check-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        width: 100%;
        padding: 0 17px;
        height: 57px;
        background: #f4f6f9;
        border-radius: 12px;
        color: #303133;
        font-size: 15px;
        .content {
          flex: 1;
          width: 100%;
          font-size: 15px;
          font-weight: 500;
          color: #c0c4cc;
          &.current {
            color: #303133;
          }
        }
        .right {
          flex: 0 0 18px;
          width: 18px;
          margin-top: 3px;
          font-size: 18px;
        }
      }
    }
  }
  .confirm {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 47px;
    line-height: 47px;
    background: linear-gradient(#4465f3 0%, #4a86f6 100%);
    font-size: 16px;
    color: #fff;
    text-align: center;
    &.current {
      bottom: 10%;
    }
  }
}
</style>
